module.exports = __webpack_public_path__ + "img/beer_id-85.dfbd207e.png";